import React, { use, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import { api } from "../../utils/apiClient";
import LoadingShimmer from "../../utils/LoadingShimmer";
import GlobalFilter from "../../components/filters/GlobalFilter";
import { showDeleteConfirm } from "../../utils/deleteConfirm";
import { toast } from "react-toastify";
import EventViewModal from "../../components/modal/EventViewModal";
import { Icon } from "@iconify/react/dist/iconify.js";
import ReadingPlanTable from "../../components/tables/ReadingPlanTable";
import ReadingPlanViewModal from "../../components/modal/ReadingPlanViewModal";
import ChurchesTable from "../../components/tables/churchesTable";
import ChurchModal from "../../components/modal/churchModal";
import ImageUploadTable from "../../components/tables/ImageUploadTable";




let searchTimeout;

const ImageUpload = () => {
      const [image, setImage] = useState(null);
      const [preview, setPreview] = useState(null);
      const [type, setType] = useState("");
      const [loading, setLoading] = useState(true);
      const [page, setPage] = useState(1);
      const [entriesPerPage, setEntriesPerPage] = useState(10);
      const [sort, setSort] = useState("createdAt");
      const [order, setOrder] = useState("desc");
      const [debouncedSearch, setDebouncedSearch] = useState("");
      const [activeTab, setActiveTab] = useState("new");
      const [dateFilters, setDateFilters] = useState({ startDate: "", endDate: "" });
      const [totalPages, setTotalPages] = useState(1);
      const [totalEntries, setTotalEntries] = useState(0);
      const [search, setSearch] = useState("");

      const imageTypes = [
            { label: "Select Type", value: "" },
            { label: "Verses", value: "verses" },
            { label: "Daily Reading", value: "daily_reading" },
            { label: "Event", value: "event" },
            { label: "Announcement", value: "announcement" },
      ];

      useEffect(() => {
            clearTimeout(searchTimeout);

            searchTimeout = setTimeout(() => {
                  setDebouncedSearch(search);
            }, 500);

            return () => clearTimeout(searchTimeout);
      }, [search]);

      const fetchImages = async () => {
            try {
                  setLoading(true);

                  const response = await api.get("/images", {
                        params: {
                              page,
                              limit: entriesPerPage,
                              sort,
                              order,
                              search: debouncedSearch?.trim() || "",
                              status: activeTab,
                              startDate: dateFilters.startDate || undefined,
                              endDate: dateFilters.endDate || undefined,
                        }
                  });

                  setImage(response.data.data || []);
                  setTotalPages(response.data.pagination.totalPages || 1);
                  setTotalEntries(response.data.pagination.total || 0);
            } catch (error) {
                  console.error("Error fetching images:", error);
                  toast.error("Failed to load images");
            } finally {
                  setLoading(false);
            }
      }

      useEffect(() => {
            fetchImages();
      }, [page, entriesPerPage, sort, order, debouncedSearch, activeTab, dateFilters]);

      const handleUpload = async () => {
            if (!image) {
                  alert("Please select an image");
                  return;
            }

            if (!type) {
                  alert("Please select image type");
                  return;
            }

            try {
                  const formData = new FormData();
                  formData.append("image", image);
                  formData.append("type", type);

                  console.log("Uploading image with data:", { image, type });

                  const res = await api.post("/images", formData, {
                        headers: {
                              "Content-Type": "multipart/form-data",
                        },
                  });

                  console.log(res.data);

                  toast.success("Image uploaded successfully");

                  // reset after upload
                  setImage(null);
                  setPreview(null);
                  setType("");

            } catch (err) {
                  console.error(err);
                  toast.error("Upload failed");
            }
      };

      const handleFileChange = (file) => {
            if (!file) return;

            setImage(file);
            setPreview(URL.createObjectURL(file));
      };

      const handleDrop = (e) => {
            e.preventDefault();
            const file = e.dataTransfer.files[0];
            handleFileChange(file);
      };

      const handleRemove = () => {
            setImage(null);
            setPreview(null);
      };

      const handleDelete = async (id) => {
            try {
                  await api.delete(`/images/${id}`);

                  toast.success("Image deleted successfully");

                  // Refresh list after delete
                  fetchImages();

            } catch (error) {
                  console.error(error);
                  toast.error("Failed to delete image");
            }
      };

      const handleDeleteClick = (id) => {
            showDeleteConfirm(() => handleDelete(id));
      }

      return (
            <>
                  <div className="page-header-row">
                        <Breadcrumb title="Image Verse" />
                  </div>
                  {loading ? (
                        < LoadingShimmer
                              columns={8}
                              rows={6}
                              avatarColumnIndex={2}
                              actionColumnIndex={7}
                        />
                  ) : (
                        <ImageUploadTable
                              image={image}
                              onDelete={handleDeleteClick}
                              page={page}
                              setPage={setPage}
                              entriesPerPage={entriesPerPage}
                              setEntriesPerPage={setEntriesPerPage}
                              totalPages={totalPages}
                              setTotalPages={setTotalPages}
                              totalEntries={totalEntries}
                              setTotalEntries={setTotalEntries}
                              search={search}
                              setSearch={setSearch}
                              fetchImages={fetchImages}
                        />
                  )}


            </>
      );
};

export default ImageUpload;
